import React from 'react';
import { graphql, useFragment } from 'react-relay';
import Heading from '@atlaskit/heading';
import { useIntl } from '@atlassian/jira-intl';
import type { relatedWorkHeading_versionProgress$key } from '@atlassian/jira-relay/src/__generated__/relatedWorkHeading_versionProgress.graphql';
import { Section, Summary } from '../../common/ui/styled';
import messages from './messages';

export type Props = {
	relatedWorkEdges: relatedWorkHeading_versionProgress$key;
};

export const RelatedWorkHeading = ({ relatedWorkEdges }: Props) => {
	const { formatMessage } = useIntl();

	const edges = useFragment(
		graphql`
			fragment relatedWorkHeading_versionProgress on JiraVersionRelatedWorkV2Edge
			@relay(plural: true) {
				node @required(action: NONE) {
					... on JiraVersionRelatedWorkGenericLink {
						__typename
						url
					}
					... on JiraVersionRelatedWorkConfluenceReleaseNotes {
						__typename
						url
					}
					... on JiraVersionRelatedWorkNativeReleaseNotes {
						__typename
					}
				}
			}
		`,
		relatedWorkEdges,
	);

	const totalCount = edges.length;
	const numNonPlaceholders = totalCount
		? edges.filter((edge) => {
				switch (edge?.node.__typename) {
					case 'JiraVersionRelatedWorkNativeReleaseNotes':
						return true;
					case 'JiraVersionRelatedWorkGenericLink':
					case 'JiraVersionRelatedWorkConfluenceReleaseNotes':
						return edge.node.url !== null;
					default:
						return false;
				}
			}).length
		: 0;

	return (
		<Section isCollapsible={false}>
			<Heading size="xsmall" as="h4">
				{formatMessage(messages.relatedWorkHeading)}
			</Heading>
			<Summary>
				{totalCount === 0
					? formatMessage(messages.noItems)
					: formatMessage(messages.summaryText, {
							numNonPlaceholders,
							totalCount,
						})}
			</Summary>
		</Section>
	);
};
